export enum SelectedDataBehaviour {
  Emit = 'emit',
  Dispatch = 'dispatch'
}
